import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  removeCartItem,
  updateCartItemQuantity,
} from "../../Components/redux/cartItemsSlice";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { emptyCart, trash } from "../../assets/images";

const Cart = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const navigate = useNavigate();

  const cartItems = useSelector((state) => state.cartItems.items);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const userId = useSelector((state) => state.user.id);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn || !userId) {
      navigate(`/${currentLanguage}/login`);
      toast.error(t("Zəhmət olmasa giriş edin"));
    }
  }, [isLoggedIn, userId, currentLanguage, navigate, t]);

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          "https://www.elzabeauty.az/elza/dashboard.php"
        );
        setProducts(res.data.data || []);
      } catch (err) { 
        console.error("Ürünler alınamadı:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // en üste ekle: 
  const calculateTotalPrice = () => {
    return cartItems.reduce((total, item) => {
      const product = getProductById(item.product_id);
      if (!product) return total;

      const price = product.secondPrice
        ? Number(product.secondPrice)
        : Number(product.firstPrice);
      return total + price * item.quantity;
    }, 0);
  };

  const getProductById = (id) => products.find((p) => p.id == id);

  const handleRemove = async (product_id) => {
    if (!userId) return;
    try {
      await axios.delete("https://www.elzabeauty.az/elza/cartItems.php", {
        data: new URLSearchParams({ user_id: userId, product_id }),
      });
      dispatch(removeCartItem(product_id));
      toast.error(t("Məhsul səbətdən çıxarıldı"));
    } catch (err) {
      console.error("Silme hatası:", err);
      alert(t("Ürün sepetten silinirken bir hata oluştu."));
    }
  };

  const handleQuantityChange = async (product_id, newQuantity) => {
    if (!userId || newQuantity < 1) return;

    try {
      // Eski ürünü önce sil
      await axios.delete("https://www.elzabeauty.az/elza/cartItems.php", {
        data: new URLSearchParams({ user_id: userId, product_id }),
      });

      // Sonra yeni miktarla ekle
      await axios.post(
        "https://www.elzabeauty.az/elza/cartItems.php",
        new URLSearchParams({
          user_id: userId,
          product_id,
          quantity: newQuantity,
        })
      );

      dispatch(updateCartItemQuantity({ product_id, quantity: newQuantity }));
    } catch (error) {
      console.error("Miqdar güncellenemedi:", error);
    }
  };

  if (loading)
    return <div className="text-center mt-8">{t("Yüklənir...")}</div>;
  if (cartItems.length === 0)
    return (
      <div className="flex max-w-containerSm md:max-w-container mx-auto flex-col md:flex-row justify-center items-center gap-4 py-20">
        <div>
          <img
            className="w-80 rounded-lg p-4 mx-auto"
            src={emptyCart}
            alt="emptyCart"
          />
        </div>
        <div className="max-w-[500px] p-4 py-8 bg-white flex gap-4 flex-col items-center rounded-md shadow-lg">
          <h1 className="font-titleFont text-xl font-bold">
            {t("SƏBƏTİNİZ BOŞDUR")}
          </h1>
          <p className="text-sm text-center px-10 -mt-2">
            {t(
              "Bütün kateqoriyalar üzrə ən son təqdim etdiyimiz məhsullarla tanış olun"
            )}
          </p>
          <Link to={`/${currentLanguage}/products`}>
            <button className="bg-[#181D27] rounded-md cursor-pointer hover:bg-black active:bg-gray-900 px-8 py-2 font-titleFont font-semibold text-lg text-gray-200 hover:text-white duration-300">
              {t("Məhsullara keçid et")}
            </button>
          </Link>
        </div>
      </div>
    );

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto py-10 md:py-20">
      <div className="flex justify-between">
        <h2 className="text-[20px] md:text-[24px] font-medium text-[#181D27]">
          {t("Səbətim")} ({cartItems.length} {t("məhsul")})
        </h2>
        <a
          className="hidden md:inline-block"
          href={`/${currentLanguage}/products`}
        >
          {" "}
          <div className="w-[505px] h-[52px] rounded-lg border border-[#E2E2E2] flex justify-center items-center font-medium">
            {t("Alış-verişə davam edin")}
          </div>
        </a>
      </div>

      <div className="md:flex justify-between mt-6 md:mt-8">
        <ul className="space-y-4">
          {cartItems?.map((item) => {
            const product = getProductById(item.product_id);
            return (
              <li
                key={item.product_id}
                className="
    border rounded-md 
    flex md:flex-row flex-col
    justify-between items-center 
    md:w-[714px] 
    h-auto md:h-[124px] 
    py-3 px-5 
    gap-4  /* yalnız mobil */
  "
              >
                {/* SOL */}
                <div className="flex gap-5 items-center w-full md:w-auto">
                  <img
                    className="md:w-[118px] h-[80px] md:h-[100px] w-[94px] object-cover rounded-[4px]"
                    src={`https://www.elzabeauty.az/elza/${product?.image1}`}
                    alt={product?.name || "Product image"}
                  />
                  <div>
                    {getLocalizedField(product, "secondPrice") ? (
                      <h4 className="text-[18px] md:text-[24px] font-medium mt-5">
                        <span className="line-through text-[#697586]  mr-2">
                          {getLocalizedField(product, "firstPrice")} ₼
                        </span>
                        <span className="text-firstColor">
                          {getLocalizedField(product, "secondPrice")} ₼
                        </span>
                      </h4>
                    ) : (
                      <h4 className="text-[18px] md:text-[24px] font-medium mt-5">
                        {getLocalizedField(product, "firstPrice")} ₼
                      </h4>
                    )}
                    <p className="text-[#181D27]">
                      {product ? product.name : t("Yüklənir...")}
                    </p>
                  </div>
                </div>

                {/* SAĞ */}
                <div
                  className="
      flex gap-16 
      md:w-auto w-full 
      md:justify-start justify-between  /* mobil düz qoyur */
      items-center
    "
                >
                  <div className="flex items-center mt-2">
                    <div>
                      <button
                        onClick={() =>
                          handleQuantityChange(
                            item.product_id,
                            item.quantity - 1
                          )
                        }
                        className="px-2 py-1 bg-gray-300 rounded-l hover:bg-gray-400"
                      >
                        -
                      </button>
                      <span className="px-4">{item.quantity}</span>
                      <button
                        onClick={() =>
                          handleQuantityChange(
                            item.product_id,
                            item.quantity + 1
                          )
                        }
                        className="px-2 py-1 bg-gray-300 rounded-r hover:bg-gray-400"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <button
                    onClick={() => handleRemove(item.product_id)}
                    aria-label={t("Favorilerden çıkar")}
                  >
                    <img alt="Trash" className="h-6 w-6" src={trash} />
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
        <div className="md:hidden mt-8">
          <a href={`/${currentLanguage}/products`}>
            {" "}
            <div className="md:w-[505px] h-[52px] rounded-lg border border-[#E2E2E2] flex justify-center items-center font-medium">
              {t("Alış-verişə davam edin")}
            </div>
          </a>
        </div>

        <div className="md:w-[505px] border border-[#E2E2E2] rounded-[20px] p-5 mt-8 md:mt-0">
          <p className="text-[#181D27] text-[20px] md:text-[24px] font-semibold">
            {t("Ümumi")}
          </p>
          <div className="h-[1px] w-full bg-[#E2E2E2] my-5"></div>
          <div className="flex justify-between">
            <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
              {t("Ümumi")}:
            </p>
            <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
              {calculateTotalPrice().toFixed(2)} ₼
            </p>
          </div>
          <div className="mt-6">
            <a href={`/${currentLanguage}/locations`}>
              {" "}
              <div className="md:w-[457px] h-[52px] rounded-lg bg-[#181D27] flex justify-center items-center font-medium text-white">
                {t("Davam Et")}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
